// src/pages/packageDefinitions/index.jsx
import React, { useMemo, useRef } from "react";
import { Button } from "primereact/button";
import { useLanguage } from "../../contexts/LanguageContext";
import PackageDefinitionsTable from "./components/PackageDefinitionsTable";
import PackageDefinitionsFilters from "./components/PackageDefinitionsFilters";
import usePackageDefinitionsData from "./hooks/usePackageDefinitionsData";
import usePackageDefinitionsForm from "./hooks/usePackageDefinitionsForm";
import PackageDefinitionsForm from "./components/PackageDefinitionsForm";

export default function PackageDefinitionsPage() {
  const { th } = useLanguage();

  const {
    rows,
    loading,
    totalCount,
    pagination,
    filters,
    filterFields,
    customFilterTypes,
    customFilterOptions,
    onPageChange,
    handleApplyFilters,
    handleResetFilters,
    handleSearch,
    handleEdit,
    handleShowDetail,
    handleRefresh,
  } = usePackageDefinitionsData();

  const formProps = usePackageDefinitionsForm(handleRefresh);

  const columnsRef = useRef(null);
  const columns = useMemo(
    () => [
      { field: "packageName", header: th("packageDefinitions.packageName") },
      { field: "description", header: th("packageDefinitions.description") },
      { field: "groupName", header: th("packageDefinitions.group") },
      { field: "isInUse", header: th("packageDefinitions.usageInfo") },
    ],
    [th]
  );

  return (
    <div className="card">
      {formProps.isSaving && (
        <div className="card-overlay">
          <div className="loading-indicator">
            <i className="pi pi-spin pi-spinner" style={{ fontSize: "2rem" }} />
          </div>
        </div>
      )}

      <div className="flex justify-content-between align-items-center mb-4">
        <h1 className="m-0">{th("packageDefinitions.title")}</h1>
        <Button
          label={th("packageDefinitions.new")}
          icon="pi pi-plus"
          onClick={formProps.handleAddNew}
        />
      </div>

      <PackageDefinitionsForm {...formProps} />

      <div className="mb-2">
        <PackageDefinitionsFilters
          filterFields={filterFields}
          columns={columnsRef.current || columns}
          customFilterTypes={customFilterTypes}
          customFilterOptions={customFilterOptions}
          handleSearch={handleSearch}
          handleApplyFilters={handleApplyFilters}
          handleResetFilters={handleResetFilters}
        />
      </div>

      <PackageDefinitionsTable
        rows={rows}
        loading={loading}
        filters={filters}
        totalCount={totalCount}
        pagination={pagination}
        onPageChange={onPageChange}
        handleEdit={handleEdit}
        handleDetail={handleShowDetail}
      />
    </div>
  );
}
